module.exports = __webpack_public_path__ + "static/media/finance_invoice.08c7cccb.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/finance_invoice.png
// module id = 251
// module chunks = 0